import React from 'react';
import type { FC } from 'react';
import { DeleteConfirmModal } from '../DeleteConfirmModal/DeleteConfirmModal';

interface DeletePositionModalProps {
    open: boolean;
    positionName?: string;
    busy?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export const DeletePositionModal: FC<DeletePositionModalProps> = ({
    open,
    positionName,
    busy,
    onCancel,
    onConfirm,
}) => (
    <DeleteConfirmModal
        open={open}
        title="Удалить позицию?"
        name={positionName}
        items={[
            'позиция исчезнет из проекта и не попадёт в отчёт;',
            'найденные по ней предложения и цены будут удалены.',
        ]}
        warnText="Чтобы вернуть позицию, её придётся добавить заново и запустить поиск."
        busy={busy}
        onCancel={onCancel}
        onConfirm={onConfirm}
    />
);